var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 7.50386C11.8411 7.50386 13.3335 8.99625 13.3335 10.8372C13.3335 12.6781 11.8411 14.1705 10.0001 14.1705C8.15919 14.1705 6.66681 12.6781 6.66681 10.8372C6.66681 8.99625 8.15919 7.50386 10.0001 7.50386ZM10.0001 8.75386C8.84955 8.75386 7.91681 9.6866 7.91681 10.8372C7.91681 11.9878 8.84955 12.9205 10.0001 12.9205C11.1507 12.9205 12.0835 11.9878 12.0835 10.8372C12.0835 9.6866 11.1507 8.75386 10.0001 8.75386ZM10.0001 4.58334C13.8447 4.58334 17.1635 7.20835 18.0844 10.887C18.1682 11.2218 17.9647 11.5612 17.6299 11.6451C17.295 11.7289 16.9556 11.5254 16.8718 11.1905C16.0894 8.06498 13.2679 5.83334 10.0001 5.83334C6.73092 5.83334 3.90855 8.0669 3.12752 11.1943C3.04388 11.5292 2.7046 11.7329 2.36971 11.6492C2.03482 11.5656 1.83113 11.2263 1.91477 10.8914C2.83401 7.21061 6.15387 4.58334 10.0001 4.58334Z",
    fill: "#051D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.d0d7ffcd9cbb841fce0aab173c7694f9.svg";
export { ForwardRef as ReactComponent };